/**
 * QUIPWA — SyncConflictBanner
 *
 * Tells the user when two devices edited the same part of a note and the text
 * merge could not combine them. Nothing was lost: the note keeps the other
 * device's text and this device's version was saved as a copy. The banner
 * links to both so the user can reconcile them by hand.
 */
import { AlertTriangle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useNoteConflicts } from '../../stores/note-conflicts-store.ts'
import { useI18n } from '../../lib/i18n/i18n-store.ts'
import './SyncConflictBanner.css'

export function SyncConflictBanner() {
  const conflicts = useNoteConflicts((s) => s.conflicts)
  const dismiss = useNoteConflicts((s) => s.dismiss)
  const navigate = useNavigate()
  const { t } = useI18n()

  if (conflicts.length === 0) return null

  return (
    <section className="sconf" aria-live="polite" aria-label={t('conflict.title')}>
      {conflicts.map((c) => (
        <div key={c.id} className="sconf-row">
          <AlertTriangle size={14} className="sconf-icon" aria-hidden="true" />
          <p className="sconf-text">{t('conflict.noteCopy', { title: c.title })}</p>
          <div className="sconf-actions">
            <button className="btn btn--warn sconf-btn" onClick={() => navigate(`/notes/${c.noteId}`)}>
              {t('conflict.openNote')}
            </button>
            <button className="btn btn--warn sconf-btn" onClick={() => navigate(`/notes/${c.copyNoteId}`)}>
              {t('conflict.openCopy')}
            </button>
            <button className="btn btn--outline sconf-btn sconf-btn--quiet" onClick={() => dismiss(c.id)}>
              {t('common.dismiss')}
            </button>
          </div>
        </div>
      ))}
    </section>
  )
}
